var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'wg-tabs': true, hindLine: _vm.$props.hideLine }},[_c('div',{ref:"refWgTabs",class:{ 'wg-tabs-box': true }},[_vm._l((_vm.tabList),function(tab){return _c('div',{key:tab.index,class:{
        'wg-tab-item': 1,
        active: _vm.tabActive === tab.index,
      },on:{"click":function($event){return _vm.methodChangeTab($event, tab.index)}}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),(!_vm.$props.hideLine)?_c('div',{staticClass:"wg-tab-line",style:({
        width: _vm.tabLineWidth + 'px',
        transform: ("translateX(" + _vm.tabLineLeft + "px)"),
      })}):_vm._e()],2),_c('div',{staticClass:"wg-slot"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }